import { MODULE_CODES } from "@medicorepay/shared";
import { Route } from "react-router-dom";
import { ModuleProtectedRoute } from "../../components/auth/ModuleProtectedRoute";
import { PermissionProtectedRoute } from "../../components/auth/PermissionProtectedRoute";
import { ApprovalCenterPage } from "../../pages/approvals/ApprovalCenterPage";
import { BatchesPage } from "../../pages/batches/BatchesPage";
import { CategoriesPage } from "../../pages/categories/CategoriesPage";
import ScheduleH1RegisterPage from "../../pages/compliance/ScheduleH1RegisterPage";
import { CreateCustomerPage } from "../../pages/customers/CreateCustomerPage";
import { CustomerLedgerPage } from "../../pages/customers/CustomerLedgerPage";
import { CustomersPage } from "../../pages/customers/CustomersPage";
import { EditCustomerPage } from "../../pages/customers/EditCustomerPage";
import { DashboardPage } from "../../pages/DashboardPage";
import ExpiryAlertDashboard from "../../pages/expiry-alerts/ExpiryAlertDashboard";
import { InvoicesListPage } from "../../pages/invoices/InvoicesListPage";
import { InvoiceViewPage } from "../../pages/invoices/InvoiceViewPage";
import { POSPage } from "../../pages/pos/POSPage";
import { CreateProductPage } from "../../pages/products/CreateProductPage";
import { EditProductPage } from "../../pages/products/EditProductPage";
import { ImportProductsPage } from "../../pages/products/ImportProductsPage";
import { ProductsPage } from "../../pages/products/ProductsPage";
import { ViewProductPage } from "../../pages/products/ViewProductPage";
import SmartReorderPage from "../../pages/reorder/SmartReorderPage";
import CashBookReportPage from "../../pages/reports/CashBookReportPage";
import CounterReportPage from "../../pages/reports/CounterReportPage";
import DayBookReportPage from "../../pages/reports/DayBookReportPage";
import EndOfDayReconciliationPage from "../../pages/reports/EndOfDayReconciliationPage";
import ExpiryReportPage from "../../pages/reports/ExpiryReportPage";
import GSTReportPage from "../../pages/reports/GSTReportPage";
import { OutstandingReportPage } from "../../pages/reports/OutstandingReportPage";
import PurchaseReportsPage from "../../pages/reports/PurchaseReportsPage";
import ReportsDashboard from "../../pages/reports/ReportsDashboard";
import SalesReportPage from "../../pages/reports/SalesReportPage";
import StockReportPage from "../../pages/reports/StockReportPage";
import SupplierOutstandingPage from "../../pages/reports/SupplierOutstandingPage";
import { CreateSalesReturnPage } from "../../pages/sales-returns/CreateSalesReturnPage";
import { SalesReturnDetailPage } from "../../pages/sales-returns/SalesReturnDetailPage";
import { SalesReturnsPage } from "../../pages/sales-returns/SalesReturnsPage";
import { StockViewPage } from "../../pages/stock/StockViewPage";

export const protectedFoundationRoutes = (
  <>
    <Route path="/dashboard" element={<DashboardPage />} />
    <Route
      path="/pos"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <POSPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/products"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <ProductsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/products/new"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <CreateProductPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/products/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <ViewProductPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/products/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <EditProductPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/products/import"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <ImportProductsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/categories"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <CategoriesPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/batches"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <BatchesPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/expiry-alerts"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <ExpiryAlertDashboard />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reorder"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <SmartReorderPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/inventory"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <StockViewPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/customers"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.CUSTOMER_MGMT}>
          <CustomersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/customers/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.CUSTOMER_MGMT}>
          <CreateCustomerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/customers/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.CUSTOMER_MGMT}>
          <EditCustomerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/customers/:id/ledger"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.CUSTOMER_MGMT}>
          <CustomerLedgerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/invoices"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <InvoicesListPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/invoices/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <InvoiceViewPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/sales-returns"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <SalesReturnsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/sales-returns/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <CreateSalesReturnPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/sales-returns/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <SalesReturnDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/approvals"
      element={
        <PermissionProtectedRoute requiredPermission="approvals:review">
          <ApprovalCenterPage />
        </PermissionProtectedRoute>
      }
    />
    <Route
      path="/compliance/schedule-h1"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.COMPLIANCE}>
          <ScheduleH1RegisterPage />
        </ModuleProtectedRoute>
      }
    />
    <Route path="/reports/outstanding" element={<OutstandingReportPage />} />
    <Route
      path="/reports"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <ReportsDashboard />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/sales"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <SalesReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/stock"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <StockReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/expiry"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <ExpiryReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/gst"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.COMPLIANCE}>
          <GSTReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/purchases"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <PurchaseReportsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/day-book"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <DayBookReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/cash-book"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <CashBookReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/counter"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <CounterReportPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/end-of-day"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <EndOfDayReconciliationPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/reports/supplier-outstanding"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.REPORTS}>
          <SupplierOutstandingPage />
        </ModuleProtectedRoute>
      }
    />
  </>
);
